export default class backgroundImage {
    constructor() {
        return (scope, element, attrs) => {
            attrs.$observe('backgroundImage', (value) => {
                element.css({
                    'background-image': 'url(' + value + ')'
                });
            })
        }    
    }
}
